
{
  "familyId": "STU-COMBINEER",
  "questions": [
    {
      "id": "STU-COMBINEER-001",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je moet een werkstuk maken over het klimaat in de Sahara. Welke zoekterm levert de beste resultaten op?",
      "context": null,
      "options": ["klimaat Sahara woestijn", "werkstuk maken", "Sahara", "weer vandaag"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoekstrategieën",
            "content": "Gebruik de belangrijkste woorden uit je vraag als zoektermen. Combineer: wat je zoekt (klimaat) + waar (Sahara) + type (woestijn). Hoe specifieker, hoe beter de resultaten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "search_strategy",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De beste zoekterm combineert de belangrijkste woorden uit je vraag: 'klimaat' (wat je zoekt), 'Sahara' (waar), en 'woestijn' (type gebied). Hoe specifieker je zoektermen, hoe beter de resultaten. Onthoud: combineer altijd meerdere zoekwoorden voor gerichte resultaten.",
        "solutionSteps": [
          "Wat zoek je? → klimaat",
          "Waar gaat het over? → Sahara",
          "Welk type gebied? → woestijn",
          "Combineer: 'klimaat Sahara woestijn'",
          "Dit geeft de meest specifieke resultaten"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Klimaat Sahara woestijn' combineert de belangrijkste zoektermen voor specifieke resultaten.",
          "1": "Je dacht waarschijnlijk dat je moet zoeken op wat je moet doen ('werkstuk maken'). Maar je moet zoeken op je onderwerp, niet op de opdracht. 'Werkstuk maken' geeft tips over werkstukken, niet over het klimaat van de Sahara.",
          "2": "Je dacht waarschijnlijk dat één zoekwoord genoeg is. Maar alleen 'Sahara' is te breed — je krijgt dan informatie over alles in de Sahara (dieren, geschiedenis, reizen), niet specifiek over het klimaat. Onthoud: combineer meerdere zoekwoorden.",
          "3": "Je dacht waarschijnlijk dat 'weer' en 'klimaat' hetzelfde zijn. Maar 'weer vandaag' gaat over het actuele weer, niet over het klimaat (het gemiddelde weer over langere tijd). Onthoud: weer ≠ klimaat."
        }
      }
    },
    {
      "id": "STU-COMBINEER-002",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je hebt een tabel met temperatuurgegevens én een kaart van Europa. Welke conclusie kun je trekken door deze twee bronnen te combineren?",
      "context": null,
      "options": [
        "Landen in het zuiden van Europa zijn gemiddeld warmer dan landen in het noorden.",
        "Europa heeft meer landen dan andere continenten.",
        "De temperatuur in Europa is overal hetzelfde.",
        "Kaarten zijn altijd betrouwbaarder dan tabellen."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bronnen combineren",
            "content": "Door een tabel (temperatuurgegevens) te combineren met een kaart (ligging van landen) kun je verbanden zien: landen in het zuiden hebben hogere temperaturen dan landen in het noorden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "combine_sources_geography",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Door een tabel met temperaturen te combineren met een kaart van Europa, kun je zien dat landen in het zuiden (dichter bij de evenaar) gemiddeld warmer zijn dan landen in het noorden. Dit verband zie je alleen als je beide bronnen samenvoegt — de tabel geeft de cijfers, de kaart laat de ligging zien.",
        "solutionSteps": [
          "Bron 1: tabel met temperatuurgegevens per land",
          "Bron 2: kaart met ligging van landen in Europa",
          "Combineer: koppel temperatuur (tabel) aan ligging (kaart)",
          "Conclusie: zuidelijke landen = hogere temperaturen",
          "Dit verband zie je alleen door beide bronnen samen te gebruiken"
        ],
        "distractorExplanations": {
          "0": "Goed! Door de tabel (temperaturen) en de kaart (ligging) te combineren, zie je dat zuidelijke landen warmer zijn.",
          "1": "Je dacht waarschijnlijk dat je het aantal landen kunt vergelijken met deze bronnen. Maar een temperatuurtabel en een kaart van Europa zeggen niets over het aantal landen op andere continenten. Onthoud: trek alleen conclusies die je uit de gegeven bronnen kunt halen.",
          "2": "Je dacht waarschijnlijk dat de temperatuur overal gelijk is. Maar de tabel laat juist zien dat temperaturen per land verschillen. Door de kaart erbij te pakken, zie je dat dit samenhangt met de ligging (zuiden = warmer).",
          "3": "Je dacht waarschijnlijk dat je moet kiezen welke bron beter is. Maar het gaat om het combineren van bronnen, niet om het vergelijken ervan. Beide bronnen zijn nuttig voor verschillende informatie."
        }
      }
    },
    {
      "id": "STU-COMBINEER-003",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "In een boek over dieren staat een tekst over de wolf én een staafdiagram over het aantal wolven in Europa. Wat kun je het best doen om een goed antwoord te geven op de vraag 'Gaat het goed met de wolf in Europa?'",
      "context": null,
      "options": [
        "Beide bronnen gebruiken: de tekst voor uitleg en het diagram voor cijfers.",
        "Alleen het diagram bekijken, want cijfers zijn altijd betrouwbaar.",
        "Alleen de tekst lezen, want tekst is belangrijker dan grafieken.",
        "Op internet zoeken naar een ander antwoord."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Informatie combineren",
            "content": "Voor een goed antwoord gebruik je meerdere bronnen. De tekst geeft uitleg en context. Het diagram geeft harde cijfers. Samen geven ze een compleet beeld.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "combine_text_and_data",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Voor een compleet antwoord combineer je verschillende bronnen. De tekst geeft uitleg en context (waarom het goed of slecht gaat met de wolf). Het staafdiagram geeft harde cijfers (hoeveel wolven er zijn). Samen geven ze een completer beeld dan elk apart. Onthoud: tekst = het verhaal, diagram = de feiten.",
        "solutionSteps": [
          "Welke bronnen heb je? Tekst + staafdiagram",
          "Tekst → geeft uitleg en context (waarom)",
          "Staafdiagram → geeft cijfers en trends (hoeveel)",
          "Combineer beide voor een compleet antwoord",
          "Conclusie: gebruik altijd meerdere bronnen als ze beschikbaar zijn"
        ],
        "distractorExplanations": {
          "0": "Goed! Door tekst (uitleg) en diagram (cijfers) te combineren, krijg je het meest complete antwoord.",
          "1": "Je dacht waarschijnlijk dat cijfers altijd genoeg zijn. Maar cijfers zonder context vertellen niet het hele verhaal. Het diagram laat zien hoeveel wolven er zijn, maar de tekst legt uit waarom het aantal stijgt of daalt. Onthoud: cijfers + uitleg = compleet beeld.",
          "2": "Je dacht waarschijnlijk dat tekst belangrijker is dan grafieken. Maar tekst zonder cijfers mist concrete onderbouwing. Het diagram geeft harde feiten die je verhaal sterker maken. Onthoud: beide bronnen vullen elkaar aan.",
          "3": "Je dacht waarschijnlijk dat je altijd op internet moet zoeken. Maar de informatie staat al in het boek. Gebruik eerst de beschikbare bronnen — dat is efficiënter en betrouwbaarder dan willekeurig op internet zoeken."
        }
      }
    },
    {
      "id": "STU-COMBINEER-004",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je leest een artikel over gezond eten. Daarin staat een tabel met voedingswaarden én een cirkeldiagram over eetgewoonten van jongeren. Welke vraag kun je beantwoorden door beide bronnen te combineren?",
      "context": null,
      "options": [
        "Eten jongeren genoeg groente volgens de voedingsrichtlijnen?",
        "Hoeveel calorieën zit er in een appel?",
        "Wat is het favoriete eten van volwassenen?",
        "Hoe maak je een gezonde maaltijd klaar?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bronnen combineren voor conclusies",
            "content": "De tabel geeft voedingsrichtlijnen (hoeveel groente je nodig hebt). Het cirkeldiagram laat zien wat jongeren eten. Door te combineren kun je concluderen of jongeren genoeg groente eten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "combine_for_conclusion",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Door de tabel (voedingsrichtlijnen) te combineren met het cirkeldiagram (wat jongeren eten), kun je concluderen of jongeren genoeg groente eten. De tabel zegt hoeveel je nodig hebt, het diagram laat zien hoeveel jongeren daadwerkelijk eten. Alleen door beide bronnen samen te gebruiken kun je deze vergelijking maken.",
        "solutionSteps": [
          "Bron 1: tabel met voedingsrichtlijnen (hoeveel groente je nodig hebt)",
          "Bron 2: cirkeldiagram (wat jongeren daadwerkelijk eten)",
          "Combineer: vergelijk de richtlijn met de werkelijkheid",
          "Conclusie: je kunt beantwoorden of jongeren genoeg groente eten",
          "De andere vragen kun je niet beantwoorden met deze twee bronnen"
        ],
        "distractorExplanations": {
          "0": "Goed! Door de voedingsrichtlijnen (tabel) te vergelijken met de eetgewoonten (diagram), kun je deze vraag beantwoorden.",
          "1": "Je dacht waarschijnlijk dat je hiervoor beide bronnen nodig hebt. Maar het aantal calorieën in een appel kun je direct uit de tabel aflezen — daar heb je het cirkeldiagram niet bij nodig. Onthoud: 'combineren' betekent dat je informatie uit beide bronnen samenvoegt.",
          "2": "Je dacht waarschijnlijk dat het cirkeldiagram over volwassenen gaat. Maar het diagram gaat over jongeren, niet over volwassenen. Deze vraag kun je niet beantwoorden met deze bronnen. Onthoud: lees goed welke informatie elke bron bevat.",
          "3": "Je dacht waarschijnlijk dat een voedingstabel ook recepten bevat. Maar geen van beide bronnen bevat recepten of bereidingswijzen. Onthoud: trek alleen conclusies die je uit de gegeven bronnen kunt halen."
        }
      }
    },
    {
      "id": "STU-COMBINEER-005",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Een leerling maakt een presentatie over watervervuiling. Hij heeft een foto van een vervuilde rivier, een grafiek over waterkwaliteit, en een tekst van een milieuorganisatie. In welke volgorde kan hij deze bronnen het best gebruiken?",
      "context": null,
      "options": [
        "Foto als opening, grafiek voor feiten, tekst voor uitleg en oplossingen.",
        "Alleen de foto laten zien, want een beeld zegt meer dan duizend woorden.",
        "Alleen de tekst voorlezen, want tekst is het belangrijkst.",
        "Eerst de grafiek, dan de foto, dan de tekst — altijd op alfabetische volgorde."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bronnen ordenen in een presentatie",
            "content": "Een goede presentatie combineert bronnen strategisch: begin met iets dat de aandacht trekt (foto), onderbouw met feiten (grafiek), en sluit af met uitleg en oplossingen (tekst).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "combine_presentation_order",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Een sterke presentatie combineert bronnen in een logische volgorde: de foto trekt de aandacht (opening), de grafiek onderbouwt met feiten (middenstuk), en de tekst geeft uitleg en oplossingen (afsluiting). Zo bouw je een overtuigend verhaal op. Onthoud: aandacht → feiten → uitleg.",
        "solutionSteps": [
          "Welke bronnen heb je? Foto, grafiek, tekst",
          "Opening: foto trekt de aandacht (emotie)",
          "Middenstuk: grafiek geeft harde feiten (onderbouwing)",
          "Afsluiting: tekst geeft uitleg en oplossingen (conclusie)",
          "Volgorde: foto → grafiek → tekst"
        ],
        "distractorExplanations": {
          "0": "Goed! Foto (aandacht) → grafiek (feiten) → tekst (uitleg) is een logische en overtuigende opbouw.",
          "1": "Je dacht waarschijnlijk dat een foto genoeg is voor een goede presentatie. Maar alleen een foto mist feiten en uitleg. Een presentatie wordt sterker door meerdere bronnen te combineren. Onthoud: een beeld trekt aandacht, maar feiten en uitleg maken het compleet.",
          "2": "Je dacht waarschijnlijk dat tekst het belangrijkst is. Maar alleen tekst voorlezen maakt een presentatie saai en mist visuele ondersteuning. Door een foto en grafiek toe te voegen wordt het sterker en overtuigender.",
          "3": "Je dacht waarschijnlijk dat je bronnen op alfabetische volgorde moet zetten. Maar bronnen orden je op logica en overtuigingskracht, niet op alfabet. Begin met aandacht trekken (foto), dan feiten (grafiek), dan uitleg (tekst)."
        }
      }
    }
  ]
}
